import React from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NotificationClose } from "../UI/Icons/Notifications";
import Notification from "../UI/Notification";
import styled from "styled-components";
import { rem } from "polished";

const StyledToastContainer = styled(ToastContainer)`
  /* .toast-container */
  position: fixed;
  width: ${rem("540px")};
  border-radius: 16px;
  font-family: Inter;
  ${({ theme }) => theme.mobileL`
    width: 100%;
  `}

  > div {
    border-radius: 16px;
  }
`;

export const notify = (notificationHeader, notificationBody, type) => {
  const options = {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    closeButton: <NotificationClose />,
  };

  toast(
    <Notification
      header={notificationHeader}
      body={notificationBody}
      type={type}
    />,
    options
  );
};

export const NotificationContainer = ({ isPrivateLabel }) => {
  toast.configure();
  return <StyledToastContainer isPrivateLabel={isPrivateLabel} />;
};
